import { setupConstants } from "./constants";

const INITIAL_STATE = {
  topLevels: [],
  subLevels: [],
  leaf: [],
  subjects: [],
  evaluations: [],
  level: {},
  userDashboardOjects: [],
  newProfilePhotos: [],
  kpis: {},
  collection: [],
  sysUsers: [],
};

export function setup(state = INITIAL_STATE, action) {
  switch (action.type) {
    case setupConstants.GET_COLLECTION:
      return {
        ...state,
        collection: action.collection,
      };

    case setupConstants.UPDATE_PARAMETER:
      let newCollection = state.collection.map((row) => {
        if (row.param_id === action.param_id) {
          row.param_value = action.data.param_value;
          row.login_id = action.userID;
          row.justUpdated = 1;
        }
        return row;
      });

      return {
        ...state,
        collection: newCollection,
      };

    case setupConstants.LEVEL_LOAD:
      // If level 0
      if (action.levels[0].type_id === "1") {
        return {
          ...state,
          topLevels: action.levels,
          subLevels: [],
        };
      } else if (action.levels[0].type_id === "2") {
        return {
          ...state,
          subLevels: action.levels,
          leaf: [],
        };
      } else if (action.levels[0].type_id === "3") {
        return {
          ...state,
          subLevels: action.caller === 2 ? [...state.subLevels] : [],
          leaf: action.levels,
        };
      } else {
        return {
          ...state,
        };
      }

    case setupConstants.CREATE_EVALUATION:
      let evaluationsCopy = [...state.evaluations];
      evaluationsCopy.push(action.evaluation);

      return {
        ...state,
        evaluations: evaluationsCopy,
      };

    case setupConstants.UPDATE_EVALUATION:
      let evaluationsNew = state.evaluations.map((ev) => {
        if (ev.evaluation_id === action.evaluation_id) {
          return { ...ev, ...action.data };
        } else {
          return ev;
        }
      });

      return {
        ...state,
        evaluations: evaluationsNew,
      };

    case setupConstants.EVALUATIONS_LEVEL_LOAD:
      return {
        ...state,
        evaluations: action.evaluations,
        level: action.level,
      };

    case setupConstants.SUBJECTS_LEVEL_DELETE:
      return {
        ...state,
        subjects: state.subjects.filter(
          (subject) => subject.subject_id !== action.subject_id
        ),
      };

    case setupConstants.SUBJECTS_LEVEL_LOAD:
      return {
        ...state,
        subjects: action.subjects,
        level: action.level,
      };

    case setupConstants.GET_SYS_USERS:
      return {
        ...state,
        sysUsers: action.sysUsers,
      };
    case setupConstants.LOAD_KPIS:
      return {
        ...state,
        kpis: action.kpis,
      };

    case setupConstants.LOAD_USER_DASHBOARD:
      return {
        ...state,
        userDashboardOjects: action.userDashboardOjects,
      };

    case setupConstants.LOAD_NEW_PROFILE_PHOTOS:
      return {
        ...state,
        newProfilePhotos: action.newProfilePhotos,
      };

    default:
      return state;
  }
}
